// extracted by mini-css-extract-plugin
export default {"productButtonWrapper":"index_productButtonWrapper__21J9C","productButton":"index_productButton__deRUn"};